import React from 'react';
import { SparklesIcon, Leaf, DollarSign } from 'lucide-react';
const RestaurantValueCards = () => {
  return <section className="py-20 bg-white" data-id="element-1446">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1447">
        <div className="text-center mb-16" data-id="element-1448">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-1449">
            Why restaurants choose SmartSoda
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1450">
            Traditional soda sales have declined for 20 years. Smart Soda's
            premium beverage solution is transforming dining experiences and
            boosting profits
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1451">
          {/* Card 1 - Reordered to Increase Profit Margins */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-1452">
            <div className="mb-6 bg-amber-50 p-4 rounded-full" data-id="element-1453">
              <DollarSign className="h-8 w-8 text-amber-600" data-id="element-1454" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-1455">
              Increased Profit Margins
            </h3>
            <p className="text-gray-600 text-center" data-id="element-1456">
              Boost beverage revenue with 60%+ profit margins on premium drinks
              while reducing storage costs, labor, and inventory management
              headaches.
            </p>
          </div>
          {/* Card 2 - Reordered to Elevated Dining Experience */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-1457">
            <div className="mb-6 bg-blue-50 p-4 rounded-full" data-id="element-1458">
              <SparklesIcon className="h-8 w-8 text-blue-600" data-id="element-1459" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-1460">
              Elevated Dining Experience
            </h3>
            <p className="text-gray-600 text-center" data-id="element-1461">
              Impress your guests with premium craft beverages made from premium
              clean label ingredients that complement your culinary offerings
              and enhance the overall dining experience.
            </p>
          </div>
          {/* Card 3 - Sustainable Solution */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-1462">
            <div className="mb-6 bg-green-50 p-4 rounded-full" data-id="element-1463">
              <Leaf className="h-8 w-8 text-green-600" data-id="element-1464" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-1465">
              Sustainable Solution
            </h3>
            <p className="text-gray-600 text-center" data-id="element-1466">
              Eliminate single-use bottles and packaging waste while showcasing
              your restaurant's commitment to environmental responsibility and
              sustainable practices.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-1467">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-1468">
            Book Your Free Demo Today
          </a>
        </div>
      </div>
    </section>;
};
export default RestaurantValueCards;